/** Кегль секционных заголовков (секции 6–7 и др.) */
export const LANDING_HEADING_SIZE_CLASS =
  'text-[24px] font-semibold leading-[1.2] tracking-[-0.5px] sm:text-[28px] md:text-[32px] lg:text-[38px] xl:text-[44px]'

/** Заголовок секции 7 (CTA) — 48px на больших экранах */
export const LANDING_SECTION7_HEADING_CLASS =
  'font-semibold leading-[1.2] tracking-[-0.5px] text-[#1A202C] text-[24px] sm:text-[32px] md:text-[40px] lg:text-[48px]'

/** Серый вводный текст под крупным заголовком (секции 6–7 и др.) */
export const LANDING_INTRO_SUBTITLE_CLASS =
  'text-[18px] sm:text-[20px] md:text-[22px] leading-[1.35] tracking-[-0.5px] text-[#1A202CB3]'

/** Акцентный цвет: CTA, плей, маркеры (#4649F2) */
export const LANDING_ACCENT_BG_CLASS = 'bg-[#4649F2]'
export const LANDING_ACCENT_HOVER_BG_CLASS = 'hover:bg-[#2B2FDD]'

/** Текст основных акцентных кнопок лендинга */
export const LANDING_CTA_BUTTON_TEXT_CLASS =
  'font-sans text-[16px] font-medium leading-none tracking-[-0.5px] text-white transition-colors layout-2col:text-[20px]'

export const LANDING_SECTION_SHELL_CLASS =
  'font-sans w-full tracking-[-0.5px] px-[12px] py-[56px] sm:px-[14px] sm:py-[64px] lg:py-[80px]'

/** Как оболочка секции, но без верхнего отступа (зазор задаётся блоком выше). */
export const LANDING_SECTION_SHELL_NO_TOP_CLASS =
  'font-sans w-full tracking-[-0.5px] px-[12px] pt-0 pb-[56px] sm:px-[14px] sm:pb-[64px] lg:pb-[80px]'
